export enum TireCount {
    LIST_VIEW = 10,
    GRID_VIEW = 20,
}
